import {generalRequest} from "@/lib/services/requests";

import {useMutation, useQuery} from "@tanstack/react-query";

export const useApiSearchAdminCertifications = (config) => {
    return useQuery({
        queryKey: ['admin', 'certifications', 'get', config],
        queryFn: () => ((async (config = {}) => {
            return generalRequest.get(`/admin/certifications`, config)
        })({params: config})),
    })
}


export const useApiSearchStudentCertifications = (args) => {
    return useQuery({
        queryKey: ['student', 'certifications', 'list', args],
        queryFn: ({pageParam = args.page ?? 1}) => ((async (config = {}) => {
            return generalRequest.get(`/student/certifications`, {params: config})
        })({...args, page: pageParam})),
    })
}


export const useApiCreateCertificationPDF = () => {
    return useMutation({
        mutationFn: (args) =>
            ((async (args = {}) => {
                return generalRequest.post(`/student/certification/${args.id}/pdf`, args)
            })(args))
    });

}


